const DEFAULT_BANQUET_FALLBACK_IMAGES = [
  "/images/banquet-theme-balloon-decoration-normal--decorzoom.webp",
  "/images/arch-sofa.webp",
  "/images/banner-thumbnail.webp",
  "/images/Baby-Shower-Balloon-Setup-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators-grand.webp",
  "/images/Babybox-Decoration-Setup-with-Balloons-&-Props-DecorZoom-Event-Decorators.webp",
];

const BLOCKED_REMOTE_IMAGE_PATTERNS = [
  /^https:\/\/lh3\.googleusercontent\.com\/gps-cs-s\//i,
];

const normalizeImageValue = (value) => (typeof value === "string" ? value.trim() : "");

export const isLikelyRenderableBanquetImage = (value) => {
  const normalizedValue = normalizeImageValue(value);

  if (!normalizedValue) {
    return false;
  }

  if (normalizedValue.startsWith("/")) {
    return true;
  }

  if (normalizedValue.startsWith("data:image/")) {
    return true;
  }

  if (/^https?:\/\//i.test(normalizedValue)) {
    return !BLOCKED_REMOTE_IMAGE_PATTERNS.some((pattern) => pattern.test(normalizedValue));
  }

  return false;
};

export const buildRenderableBanquetImages = (images = [], minCount = 5) => {
  const seen = new Set();
  const renderableImages = [];

  const appendImage = (value) => {
    const normalizedValue = normalizeImageValue(value);

    if (!isLikelyRenderableBanquetImage(normalizedValue) || seen.has(normalizedValue)) {
      return;
    }

    seen.add(normalizedValue);
    renderableImages.push(normalizedValue);
  };

  images.forEach(appendImage);

  // A venue with zero real photos should show a single generic placeholder, not a
  // gallery padded out with unrelated stock photos (balloon arches, baby showers, etc.)
  // that have nothing to do with the actual venue and read as broken/wrong images.
  if (!renderableImages.length) {
    return [DEFAULT_BANQUET_FALLBACK_IMAGES[0]];
  }

  return renderableImages.slice(0, Math.max(minCount, 1));
};

export const getPrimaryRenderableBanquetImage = (images = []) => buildRenderableBanquetImages(images, 1)[0];
